import { get, post } from "@Lib/request";
import { path, host } from "./url";
import * as ts from "@Types/api";
import getUUID from "@Lib/uuid";

const { newCarApiV1, newCarApiV2, newCarApiV3, usedCarApiV4, usedCarApi, newCarApiV4, usedApi } = path;

// 估价工具
export function fetchCarResourceValuation(data?: any) {
  return post(`${usedCarApiV4}/carResource/valuation`, data);
}

// 新车获取厂牌
export function getNewCarBrands(params?: any) {
  return get<any>(`${usedCarApiV4}/newcar/brands`, { ...params });
}

// 新车获取车款
export function getNewCarKinds(params?: any) {
  return get<any>(`${usedCarApiV4}/newcar/kinds`, { ...params });
}

// 新车获取车款
export function getNewCarModalYears(params?: any) {
  return get<any>(`${usedCarApiV4}/newcar/modelYears`, { ...params });
}
